var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',{attrs:{"custom-style":{
    height: '100vh',
    backgroundColor: '#fff'
  }}},[_c('page',{attrs:{"custom-style":{
      background: '#f5f5f5',
      bottom: '0',
      top: _vm.statusBarHeight
    }}},[_c('div',{staticClass:"content"},[_c('p',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.tips || '当前页面仅展示已上传检验合格证的商品')+" ")]),_c('ul',{staticClass:"select-list"},_vm._l((_vm.list.order_item),function(item){return _c('li',{key:item.item_id,staticClass:"item"},[_c('p',{staticClass:"title"},[_vm._v(_vm._s(item.ssu_name))]),_c('ul',{staticClass:"img-wrapper"},_vm._l((item.qcs),function(img,index){return _c('li',{key:img,staticClass:"item-img",on:{"click":function($event){return _vm.handleClick(img, item.qcs, index)}}},[_c('img',{attrs:{"src":img}})])}),0)])}),0)])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }